module.exports = __webpack_public_path__ + "16c48506a2a1c7c29c51bb1eca71ec04.svg";